import request from "@/utils/request";

export const payoutRequests = {
  list: (params) =>
    request({
      url: "/api/backend/integral/withdrawal/list",
      method: "GET",
      params,
    }),
  approve: (id) =>
    request({
      url: "/api/backend/integral/withdrawal/up",
      method: "POST",
      data: {
        type: 1,
        id,
      },
    }),
  paid: (id) =>
    request({
      url: "/api/backend/integral/withdrawal/payment",
      method: "POST",
      data: {
        id,
      },
    }),
  reject: (data) =>
    request({
      url: "/api/backend/integral/withdrawal/up",
      method: "POST",
      data: {
        type: 2,
        ...data,
      },
    }),
};
